<template>
  <VersionSelect v-if="plp_task_id" fluid needPlpData>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <ExpOther
        :key="otherFormKey"
        :value="data"
        @change="onChange"
        :readonly="readonly"
        :onCreate="onCreate"
        @blur="onBlur"
      />
    </template>
  </VersionSelect>
</template>

<script>
import VersionSelect from '@/components/VersionSelect'
import { mapGetters } from 'vuex'
import ExpOther from '@/components/expOther/ExpOther'

export default {
  components: { VersionSelect, ExpOther },
  computed: {
    ...mapGetters(['plp_task_id', 'subExpertiseUUID']),
    otherFormKey() {
      return `${this.plp_task_id || ''}-${this.subExpertiseUUID || 'new'}`
    },
  },
}
</script>
